import InfosCarousel from '@scripts/carousel/classes/InfosCarousel.js';

function initCarousels () {
    document.querySelectorAll('section.informations').forEach(function (el) {
        new InfosCarousel(el);
    });
}

document.addEventListener('DOMContentLoaded', initCarousels);
